<template>
    <div>{{ '.'.repeat(dotsNumber) }}</div>
</template>
<script>
    export default {
        data() {
            return {
                dotsNumber: 3
            }
        },
        mounted() {
            setInterval(() => {
                let newVal = this.dotsNumber + 1;

                if (newVal > 3) {
                    newVal = 1;
                }

                this.dotsNumber = newVal;
            }, 1000)
        }
    }
</script>
